export const SET_HOURS_LIST = 'SET_HOURS_LIST';
export const SET_ANOMALIES_LIST = 'SET_ANOMALIES_LIST';
export const SET_FORMATIONS_LIST = 'SET_FORMATIONS_LIST';
export const SET_STATS_LIST = 'SET_STATS_LIST';
export const SET_ERRORS = 'SET_ERRORS';
